function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "contact",
  transform: "translate(0.2 0.2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M21.126,27H.791A.792.792,0,0,1,0,26.209,10.975,10.975,0,0,1,7.165,15.928a8.418,8.418,0,1,1,10.888-2.989A7.147,7.147,0,0,1,27,19.855a2.907,2.907,0,0,1-5.027,1.991,2.907,2.907,0,1,1,.791-1.991,1.327,1.327,0,0,0,2.654,0,5.563,5.563,0,1,0-5.563,5.563h6.354a.791.791,0,1,1,0,1.582Z",
  fill: "#ec6423",
  stroke: "#ec6423",
  strokeMiterlimit: 10,
  strokeWidth: 0.4
}));

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.4,
    height: 27.4,
    viewBox: "0 0 27.4 27.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.8b7955d6.svg";
export { ForwardRef as ReactComponent };